import { getBedChoicesForPax } from '@koob/utils';

/**
 * KD-3732 — a room as the room-selection modal should offer it for one slot of
 * `pax` travellers.
 *
 * The availability lists, per room, every bed configuration that suits ANY of
 * the requested rooms: with a room of 3 and a room of 1, the room of 1 was also
 * offered the extra-bed configurations meant for the room of 3. Only those that
 * suit this slot are kept, on the room and on each of its promotion variants
 * (the card shows a variant's configurations once a promotion is picked). The
 * bed the room already holds is always kept, so a validated room never loses
 * the configuration it is booked with.
 *
 * `pax` may also list several slots' travellers (KD-3758): once every slot is
 * filled, the slot a pick replaces is not known, so the configurations that
 * suit ANY of them are kept, rather than the whole availability.
 */
export const withBedChoicesForPax = (room, pax) => {
  const paxes = [pax].flat().filter(Boolean);
  if (!room || paxes.length === 0) {
    return room;
  }

  const fitBedChoices = (possibility) => {
    const fitting = paxes.flatMap((slotPax) =>
      getBedChoicesForPax(possibility, slotPax),
    );

    return (possibility?.bedChoices ?? []).filter(
      (bedChoice) =>
        fitting.includes(bedChoice) || bedChoice.id === room.bed?.id,
    );
  };

  return {
    ...room,
    bedChoices: fitBedChoices(room),
    ...(room.variants
      ? {
          variants: room.variants.map((variant) => ({
            ...variant,
            bedChoices: fitBedChoices(variant),
          })),
        }
      : {}),
  };
};
